import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { hasRemarkFilter } from "../../Designer/StylesDashboard/data";

export const lsStylesFilterValStr = "styles_table_filter_obj";
export const lsFabricTrimsFilterValStr = "fab_trims_table_filter_obj";
export const lsBuyingFilterValStr = "buying_table_filter_obj";
